(function() {

    'use strict';

    var GarmentMeasurementsCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'garment-measurements.component.html',
        controller: GarmentMeasurementsCtrl,
        bindings: {
            product: '<',
            goToEquivalence: '&'
        }
    };

    GarmentMeasurementsCtrl.$inject = ['ItxScreenSizeSvc'];

    function GarmentMeasurementsCtrl(ItxScreenSizeSvc) {

        var _this = this;

        _this.positionsArray = [0,2,4,6,8];
        _this.sizeSkuDimensions = _this.product.activeDetail.colors[0].sizes;
        _this.skuDimensions = {};
        _this.isMobile = ItxScreenSizeSvc.is('xs,sm');

        _this.titleDimensions = _.each(_this.sizeSkuDimensions[0].skuDimensions, function(value){
            value.name = value.dimensionName;
        });

        _.filter(_this.skuDimensions, function(product) { 
            return product.size; 
        });

        if(_this.isMobile){
            var swiperObj;
            _this.positionsArray = _this.positionsArray.slice(0, _this.sizeSkuDimensions.length / 2 );

            setTimeout(function() {
                swiperObj = new Swiper('.swiper-measurement', {
                    speed: 800,
                    activeIndex: true,
                    pagination: {
                        el: '.swiper-nav',
                        type: 'bullets',
                        clickable: true
                    }
                });
            }, 1);
        }

    }

    angular.module('itxApp.common')
        .component('garmentMeasurements', GarmentMeasurementsCmp);

})();        
